import {
    ConfigurationItemArrayEditor,
    configurationItemArrayEditorRules,
} from '@client/components/_core/configuration/ConfigurationItemArrayEditor';
import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { Col, Row } from 'antd';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/mspr/documents')({
    staticData: {
        metadata: {
            title: 'Documents',
        },
        modules: ['mspr'],
        permissions: ['settings:update'],
        ui: {
            useParentTitle: true,
        },
    },
    component: Documents,
});

function Documents() {
    return (
        <PageController route={Route}>
            <Row>
                <Col span={12}>
                    <ConfigurationItemArrayEditor
                        title="MSP document types"
                        settingToEdit="MSPR_UPLOAD_DOCUMENT_TYPES"
                        description="Rename, add or remove an upload document type."
                        minItems={1}
                        arrayRules={[configurationItemArrayEditorRules.uniqueItems]}
                        itemRules={[{ required: true, message: 'Field is required' }]}
                        className="h-full"
                    />
                </Col>
            </Row>
        </PageController>
    );
}
